import { PurchaseOrderContractTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0823. 発注案件契約タスク法務チェック済更新
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:id/update_legal_checked
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
  legal_checked: boolean;
};

const updatePurchaseOrderContractLegalChecked = (props: Props): Promise<PurchaseOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.id}/update_legal_checked`,
    props
  );
};

export const useUpdatePurchaseOrderContractLegalChecked = () => {
  return useMutation({
    mutationFn: updatePurchaseOrderContractLegalChecked,
  });
};
